export const users = [
	{
		name: 'JAN',
		'Active User': 4000,
	},
	{
		name: 'FEB',
		'Active User': 1500,
	},
	{
		name: 'MAR',
		'Active User': 200,
	},
	{
		name: 'APR',
		'Active User': 7000,
	},
	{
		name: 'MAY',
		'Active User': 5020,
	},
	{
		name: 'JUN',
		'Active User': 605,
	},
	{
		name: 'JUL',
		'Active User': 4512,
	},
	{
		name: 'AUG',
		'Active User': 584,
	},
	{
		name: 'SEP',
		'Active User': 5689,
	},
	{
		name: 'OCT',
		'Active User': 714,
	},
	{
		name: 'NOV',
		'Active User': 2541,
	},
	{
		name: 'DEC',
		'Active User': 8475,
	},
];

export const userRows = [
	{
		id: 1,
		username: 'Jon Snow',
		avatar: 'https://commondescentmush.com/game/uploads/frank/profile.jpg',
		email: 'jon@gmail.com',
		status: 'active',
		transaction: '$120.00',
	},
	{
		id: 2,
		username: 'Frank Castle',
		avatar: 'https://commondescentmush.com/game/uploads/frank/profile.jpg',
		email: 'jon@gmail.com',
		status: 'active',
		transaction: '$120.00',
	},
	{
		id: 3,
		username: 'Jon Snow',
		avatar: 'https://commondescentmush.com/game/uploads/frank/profile.jpg',
		email: 'jon@gmail.com',
		status: 'active',
		transaction: '$120.00',
	},
	{
		id: 4,
		username: 'Jon Snow',
		avatar: 'https://commondescentmush.com/game/uploads/frank/profile.jpg',
		email: 'jon@gmail.com',
		status: 'active',
		transaction: '$120.00',
	},
	{
		id: 5,
		username: 'Jon Snow',
		avatar: 'https://commondescentmush.com/game/uploads/frank/profile.jpg',
		email: 'jon@gmail.com',
		status: 'active',
		transaction: '$120.00',
	},
	{
		id: 6,
		username: 'Jon Snow',
		avatar: 'https://commondescentmush.com/game/uploads/frank/profile.jpg',
		email: 'jon@gmail.com',
		status: 'active',
		transaction: '$120.00',
	},
	{
		id: 7,
		username: 'Jon Snow',
		avatar: 'https://commondescentmush.com/game/uploads/frank/profile.jpg',
		email: 'jon@gmail.com',
		status: 'active',
		transaction: '$120.00',
	},
	{
		id: 8,
		username: 'Jon Snow',
		avatar: 'https://commondescentmush.com/game/uploads/frank/profile.jpg',
		email: 'jon@gmail.com',
		status: 'active',
		transaction: '$120.00',
	},
	{
		id: 9,
		username: 'Jon Snow',
		avatar: 'https://commondescentmush.com/game/uploads/frank/profile.jpg',
		email: 'jon@gmail.com',
		status: 'active',
		transaction: '$120.00',
	},
];

export const productsData = [
	{
		id: 1,
		title: 'Apple Air pods',
		image: 'https://ae01.alicdn.com/kf/H48ea59eee7b346a892f830c0c1eac24eN.jpg?smt_ispass_4651318',
		stock: 125,
		status: 'active',
		price: 50.00,
	},
	{
		id: 2,
		title: 'IPhone 12 PRO',
		image: 'https://store.storeimages.cdn-apple.com/4668/as-images.apple.com/is/iphone-12-purple-select-2021?wid=470&hei=556&fmt=jpeg&qlt=95&.v=1617130317000',
		stock: 15,
		status: 'active',
		price: 1050.00,
	},
	{
		id: 3,
		title: 'Lenovo IdeaPad',
		image: 'https://m.media-amazon.com/images/I/61Dw5Z8LzJL._SL1000_.jpg',
		stock: 48,
		status: 'inActive',
		price: 700.00,
	},
	{
		id: 4,
		title: 'Apple IPad 2020',
		image: 'https://m.media-amazon.com/images/I/31kRFrOoQ+L._AC_SY780_.jpg',
		stock: 31,
		status: 'active',
		price: 750.00,
	},
	{
		id: 5,
		title: 'HUAWEI Tablets - HUAWEI Global',
		image: 'https://consumer-img.huawei.com/content/dam/huawei-cbg-site/common/mkt/plp/tablets/matepad-pro-10-8.jpg',
		stock: 74,
		status: 'active',
		price: 320.00,
	},
	{
		id: 6,
		title: 'T500 Smartwatch',
		image: 'https://m.media-amazon.com/images/I/41jPj8Yn5wS._AC_SY580_.jpg',
		stock: 12,
		status: 'active',
		price: 12.00,
	},
];
